import { render } from "./ComplaintHandleDetail.vue?vue&type=template&id=9656a4e0&scoped=true"
import script from "./ComplaintHandleDetail.vue?vue&type=script&lang=js"
export * from "./ComplaintHandleDetail.vue?vue&type=script&lang=js"

import "./ComplaintHandleDetail.vue?vue&type=style&index=0&id=9656a4e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9656a4e0"]])

export default __exports__